import { updater } from "../../utils/updater.js";

/**
 * Sidebar API factory.
 *
 */
export function sideBarFactory({ state, setState }) {
  // shorthand for setState(produce(draft => {...}))
  const updateState = updater(setState);

  const closeSlideBar = () => {
    updateState((draft) => {
      draft.lightBoxView = false;
      draft.gridView = false;
    });
    setTimeout(() => {
      updateState((draft) => {
        draft.content = null;
        draft.itemId = null;
      });
    }, 300);
  };

  const setSideBar = (component, itemId, islightbox) => {
    state.content &&
    itemId == state.itemId &&
    component.props.headerIcon === state.content.props.headerIcon
      ? closeSlideBar()
      : updateState((draft) => {
          draft.content = component;
          draft.itemId = itemId;
          islightbox
            ? (() => {
                draft.lightBoxView = true;
                draft.gridView = false;
              })()
            : (() => {
                draft.lightBoxView = false;
                draft.gridView = true;
              })();
        });
  };

  const getSideBarViewGrid = () => state.gridView;
  const getSideBarViewLightBox = () => state.lightBoxView;

  const getSideBarContent = () => state.content;

  return {
    setSideBar,
    getSideBarContent,
    closeSlideBar,
    getSideBarViewLightBox,
    getSideBarViewGrid,
  };
}

export default sideBarFactory;
